import React, { useMemo } from 'react';
import { useFloatingAssistVisibility } from '../../hooks/useFloatingAssistVisibility';
import { useAppSelector } from '../../store';
import { ASSIST_TOAST_REGISTRY } from '../../config/assistToastRegistry';
import { isNotificationDismissed } from '../../utils/notificationDismissCookie';
import FloatingAssistToast from './FloatingAssistToast';

const AssistToastHost: React.FC = () => {
  const routeVisible = useFloatingAssistVisibility();
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);

  const activeToast = useMemo(() => {
    const ctx = {
      routeVisible,
      isAuthenticated,
      isDismissed: isNotificationDismissed,
    };
    return ASSIST_TOAST_REGISTRY.find((entry) => entry.shouldShow(ctx));
  }, [routeVisible, isAuthenticated]);

  if (!activeToast) {
    return null;
  }

  return (
    <FloatingAssistToast
      key={activeToast.id}
      visible
      message={activeToast.message}
      ackLabel={activeToast.ackLabel}
      dismissCookieKey={activeToast.dismissCookieKey}
      durationMs={activeToast.durationMs}
    />
  );
};

export default AssistToastHost;
